var state = {
  userId: '',
  vin: '',
  language: '',
  socialToken: '',
  token: '',
  nickname: '',
  isOwner: '',
  avatar: ''
};
var mutations = {
  // SET_USER_NAME(state, name) {
  //   state.userName = name
  // }
  // SET_USER_INFO(state, obj) {
  //   state.userId = obj.uid
  //   state.vin = obj.vin
  //   state.language = obj.language
  //   state.nickname = obj.nickname
  //   state.token = obj.token
  //   state.isOwner = obj.isOwner
  //   state.avatar = obj.avatar
  // }
};
var actions = {
  // 设置name
  // setUserName({ commit }, name) {
  //   commit('SET_USER_NAME', name)
  // }
};
export default {
  state: state,
  mutations: mutations,
  actions: actions
};